module.exports = __webpack_public_path__ + "static/media/ios-folder.cccc139f.svg";